import { useState } from 'react';

export default function Services() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(0);

  const services = [
    {
      title: 'Renting Flexible',
      description: 'Alquila tecnología de vanguardia sin inversión inicial. Máquinas robóticas disponibles con mantenimiento incluido y actualización continua.',
      image: 'https://public.readdy.ai/ai/img_res/009c5c8c989d42d03d282736a56811ca.jpg',
      icon: 'ri-exchange-line'
    },
    {
      title: 'Desarrollo Custom',
      description: 'Tu idea, nuestra ingeniería. Diseñamos y fabricamos máquinas robóticas completamente personalizadas según tus necesidades específicas.',
      image: 'https://readdy.ai/api/search-image?query=precision%20robotic%20arm%20assembling%20custom%20industrial%20components%2C%20advanced%20manufacturing%20robot%20with%20orange%20and%20green%20accent%20lights%20performing%20detailed%20assembly%20work%2C%20high-tech%20automated%20engineering%20solution%20in%20modern%20factory%2C%20professional%20industrial%20photography&width=800&height=600&seq=custom-dev-001&orientation=landscape',
      icon: 'ri-tools-line'
    },
    {
      title: 'IA Integrada',
      description: 'Automatización inteligente y predictiva. Sistemas con inteligencia artificial que optimizan procesos y aprenden de cada operación.',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20artificial%20intelligence%20control%20panel%20with%20data%20visualization%20screens%2C%20advanced%20AI%20monitoring%20system%20with%20orange%20and%20green%20holographic%20displays%2C%20modern%20industrial%20automation%20interface%20showing%20predictive%20analytics%2C%20high-tech%20command%20center%20with%20sophisticated%20technology&width=800&height=600&seq=ai-integration-001&orientation=landscape',
      icon: 'ri-brain-line'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-4">
            Nuestras Soluciones{' '}
            <span className="inline-flex w-10 h-10 md:w-12 md:h-12 items-center justify-center">
              <i className="ri-settings-3-line text-orange-500 text-2xl md:text-3xl"></i>
            </span>{' '}
            a Medida
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-2xl h-80 md:h-96 transition-all duration-500"
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{
                transform: hoveredCard === index ? 'scale(1.05)' : 'scale(1)'
              }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
              
              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 to-green-500 rounded-xl mb-4 transition-all duration-300 ${
                  hoveredCard === index ? 'scale-110' : 'scale-100'
                }`}>
                  <i className={`${service.icon} text-white text-xl md:text-2xl`}></i>
                </div>
                
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">{service.title}</h3>
                
                <p className={`text-gray-200 text-sm md:text-base leading-relaxed transition-all duration-500 ${
                  hoveredCard === index ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0'
                }`}>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
